import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Workspace } from '@model-main/workspaces/workspace';
import { WorkspaceUtilsService } from '../../../../shared';
import { WorkspaceListType, WorkspaceObjectStarEvent } from '../workspace-object-list-element';

@Component({
    selector: 'workspace-object-list',
    templateUrl: './workspace-object-list.component.html',
    styleUrls: ['./workspace-object-list.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceObjectListComponent {

    @Input() workspaceKey: string;
    @Input() objects: Workspace.WorkspaceObject[];
    @Input() displayType = WorkspaceListType.TILE;
    @Input() canRemove = false;
    @Output() removeObject = new EventEmitter<Workspace.WorkspaceObject>();
    @Output() toggleStar = new EventEmitter<WorkspaceObjectStarEvent>();

    readonly trackWorkspaceObject: (index: number, object: Workspace.WorkspaceObject) => string | undefined = (_, object) => this.workspaceUtilsService.getWorkspaceObjectId(object);

    constructor(private workspaceUtilsService: WorkspaceUtilsService) {
    }

    onToggleStar(event: WorkspaceObjectStarEvent): void {
        this.toggleStar.emit(event);
    }

    onRemoveObject(object: Workspace.WorkspaceObject): void {
        this.removeObject.emit(object);
    }

}
